// components/SetBudget/SetBudget.js (Refactored version)
import React from 'react';
import { useSetBudgetForm } from '../../hooks/createBudgets/SetBudget/useSetBudgetForm';
import Button from '../reusable/Button/Button';
import Tabs from '../reusable/Tabs/Tabs';
import css from './SetBudget.module.css';
import { SetCustomBudget } from './SetCustomBudget';
import { SetMonthlyWeeklyBudget } from './SetMonthlyWeeklyBudget';

const SetBudget = () => {
  const { tab, handleTabChange, handleContinue } = useSetBudgetForm();

  return (
    <>
      <div className={css.wrapper}>
        <h1 className={css.title}>Set Budget</h1>
        <p className={css.text}>
          Amount and cycle can be adjusted at any time. Standard budgets will
          automatically renew, choose a custom budget if you would like to set a
          specific start date, end date or recurring cycle.
        </p>
        <Tabs tab={tab} handleTabChange={handleTabChange} type="budget" />
        <div className={css.container}>
          {(tab === 'monthly' || tab === 'weekly') && (
            <SetMonthlyWeeklyBudget type={tab} />
          )}
          {tab === 'custom' && <SetCustomBudget />}
        </div>
      </div>
      <div className={css.btn}>
        <Button styled="addClient" title="Continue" onClick={handleContinue} />
      </div>
    </>
  );
};

export default SetBudget;